import { lazy } from 'react';

const SrpfHistoricalImportScreen = lazy(() =>
  import('../pages/SrpfHistoricalImport/Screens/SrpfHistoricalImportScreen'),
);

const srpfHistoricalImportRoute = {
  public: [],
  auth: [
    // Intentionally not linked from the nav menu — reachable only by direct URL.
    {
      name: 'srpf_historical_import',
      path: '/srpf-historical-import/tool',
      component: SrpfHistoricalImportScreen,
    },
  ],
};

export default srpfHistoricalImportRoute;
